import { render, staticRenderFns } from "./TaxIdField.vue?vue&type=template&id=53756c48"
import script from "./TaxIdField.vue?vue&type=script&lang=ts"
export * from "./TaxIdField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports